import { BlocksFieldset } from 'blocks-nextjs/blocks-web-components/components/fieldset/fieldset';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatFieldset = createComponent({
  react: React,
  tagName: 'cat-fieldset',
  elementClass: BlocksFieldset
});
